import Vue from 'vue'
import Router from 'vue-router'
import Gateway from '@/components/Gateway'
import Account from '@/components/merchant/Merchant'
import Attri from '@/components/shop/Attri'
import Category from '@/components/shop/Category'
import OptionAttribute from '@/components/shop/OptionAttribute'
import Shipping from '@/components/order/Shippers'
import Listing from '@/components/shop/Listing'
import Advertisement from '@/components/market/Advertisement'
import Classify from '@/components/shop/classify'
import Article from '@/components/shop/Article'
import EditorRecommend from '@/components/market/EditorRecommend'
import Special from '@/components/market/Special'
import Brand from '@/components/shop/Brand'
import Order from '@/components/order/Order'
import Invoice from '@/components/merchant/Invoice'
import Payments from '@/components/merchant/Payments'
import ShoppingTabs from '@/components/shop/ShoppingTabs'
import Coupon from '@/components/market/Coupon'
import dev from '@/components/merchant/dev'
import Sale from '@/components/market/Sale'
import sso from '@/components/sso'
import Review from '@/components/order/Review'
import Buyer from '@/components/order/Buyer'
import DefaultPage from '@/components/DefaultPage'
import Sites from '@/components/System/Sites'
import Template from '@/components/shop/Template'
import Domains from '@/components/merchant/Domains'
import OrderDetail from '@/components/order/OrderDetail'
import Layout from '@/components/Layout'
Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: process.env.VUE_APP_BASE_UPL,
  base: '/admin/',
  routes: [
    {
      path: '/',
      redirect: '/overview'
    },
    {
      path: '/system',
      component: DefaultPage,
      children: [
        {
          path: 'sites',
          component: Sites
        }
      ]
    },
    {
      path: '/overview',
      name: 'Gateway',
      component: Gateway
    },
    {
      path: '/shop',
      component: DefaultPage,
      redirect: '/system/sites',
      children: [
        {
          path: 'template',
          component: Template
        },
        {
          path: 'attri',
          name: 'Attri',
          component: Attri
        },
        {
          path: 'category',
          name: 'Category',
          component: Category
        },
        {
          path: 'optionmap',
          name: 'OptionAttribute',
          component: OptionAttribute
        },
        {
          path: 'classify',
          name: 'Classify',
          component: Classify
        },
        {
          path: 'topic',
          name: 'Article',
          component: Article
        },
        {
          path: 'shoppingtabs',
          name: 'ShoppingTabs',
          component: ShoppingTabs
        },
        {
          path: 'listing',
          name: 'Listing',
          component: Listing
        },
        {
          path: 'brand',
          name: 'Brand',
          component: Brand
        }
      ]
    },
    {
      path: '/merchant',
      component: DefaultPage,
      redirect: '/system/sites',
      children: [
        {
          path: 'domain',
          component: Domains
        },
        {
          path: 'developer',
          name: 'dever',
          component: dev
        },
        {
          path: 'invoice',
          name: 'Invoice',
          component: Invoice
        },
        {
          path: 'payment',
          name: 'Payments',
          component: Payments
        },
        {
          path: 'store',
          name: 'Account',
          component: Account
        }
      ]
    },
    {
      path: '/order',
      component: Layout,
      redirect: '/order/order',
      children: [
        {
          path: 'logics',
          name: 'Shipping',
          component: Shipping
        },
        {
          path: 'developer',
          name: 'dever',
          component: dev
        },
        {
          path: 'order',
          name: 'Order',
          component: Order
        },
        {
          path: 'review',
          name: 'Review',
          component: Review
        },
        {
          path: 'buyer',
          name: 'Buyer',
          component: Buyer
        },
        {
          path: 'detail/:id',
          name: 'OrderDetail',
          component: OrderDetail
        }
      ]
    },
    {
      path: '/marketing',
      component: DefaultPage,
      redirect: '/order/order',
      children: [
        {
          path: 'advertisment',
          name: 'Advertisement',
          component: Advertisement
        },
        {
          path: 'editorrecommend',
          name: 'EditorRecommend',
          component: EditorRecommend
        },
        {
          path: 'specials',
          name: 'Specials',
          component: Special
        },
        {
          path: 'coupon',
          name: 'Coupon',
          component: Coupon
        },
        {
          path: 'snapdeal',
          name: 'Sale',
          component: Sale
        }
      ]
    },
    {
      path: '/sso',
      name: 'sso',
      component: sso
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js